export { default as QuickBookingSlots } from './QuickBookingSlots'
